import { Resources } from 'constants/resources';

import CheckIcon from '@mui/icons-material/Check';
import { useCreatePathWithQuery } from 'hooks/useCreatePathWithQuery';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useGetOne } from 'react-admin';
import { Link } from 'react-router-dom';
import { ListItemAvatar, ListItemText } from 'shared/mui/List';
import { Typography } from 'shared/mui/Typography';
import { NotificationPopperListItem } from 'shared/widgets/Notification/NotificationPopper/NotificationPopperListItem/NotificationPopperListItem';
import { IconButtonStyled } from 'shared/widgets/Notification/NotificationPopper/NotificationPopperListItem/NotificationPopperListItemOrder/NotificationPopperListItemOrder.styled';
import { Commission } from 'types/embedded/commission';
import { Notification, NotificationBodyTask } from 'types/embedded/notification';

type Props = {
  notification: Notification<NotificationBodyTask>;
  onSuccess?: () => void;
  dataId: string;
};

export const NotificationPopperListItemTask: React.FC<Props> = ({ notification, dataId }) => {
  const translate = useTypedTranslate();
  const commissionId = 'commission' in notification.body ? notification.body.commission : '';
  const { createPathWithQuery } = useCreatePathWithQuery();

  const { data: commission, isLoading } = useGetOne<Commission>(
    Resources.Commissions,
    { id: commissionId },
    { enabled: !!commissionId },
  );

  return (
    <NotificationPopperListItem data-id={dataId}>
      <ListItemAvatar>
        <IconButtonStyled>
          <CheckIcon htmlColor="#ffffff" />
        </IconButtonStyled>
      </ListItemAvatar>
      <ListItemText
        primary={
          <>
            {isLoading ? (
              translate('app.common.loading')
            ) : (
              <Typography component="span">
                {translate('app.notificationPopper.taskTitle', {
                  merchant: commission?.merchant?.name,
                  provider: commission?.provider?.name,
                })}{' '}
                <Link
                  to={createPathWithQuery({
                    resource: Resources.Commissions,
                    id: commission?.id,
                    type: 'show',
                  })}
                >
                  {translate('app.notificationPopper.commission')}
                </Link>
                .
              </Typography>
            )}
          </>
        }
        primaryTypographyProps={{ component: 'div', sx: { marginBottom: '8px' } }}
        sx={{ margin: 0 }}
      />
    </NotificationPopperListItem>
  );
};
